$(document).ready(function() {
    var $ = jQuery;

    // Apply accordion functionality to each section with the class 'accordion-section' independently
    $(".common-faq").each(function() {
        var $accordionSection = $(this);

        // Hide all accordion bodies, except the first one within this section
        $accordionSection.find(".accordion-box .accordion_body").hide();
        $accordionSection.find(".accordion-box:first .accordion_body").show();
        $accordionSection.find(".accordion-box:first").addClass("open");

        // Click event for accordion headings
        $accordionSection.find(".accordion-heading").click(function() {
            var $accordionBox = $(this).closest(".accordion-box"),
                $accordionBody = $accordionBox.find(".accordion_body");

            // Check if the clicked accordion is already open
            if (!$accordionBox.hasClass("open")) {
                // Close all other accordion boxes within this section
                $accordionSection.find(".accordion-box").removeClass("open").find(".accordion_body").slideUp();

                // Open the clicked accordion box
                $accordionBody.slideDown();
                $accordionBox.addClass("open");
            }
        });
    });
});






$(document).ready(function(){
     jQuery(".video-container video").on("pause", function (e) {
    jQuery(this).closest(".video-container").find(".play-gif").fadeIn(500);
});
   jQuery(".video-container video").on("play", function (e) {
    jQuery(this).closest(".video-container").find(".play-gif").fadeOut(500);
});
  
	$('#partners_logo').owlCarousel({
	     margin:30,
	     loop:true,
		 slideSpeed : 300,
		paginationSpeed : 400,
		autoplay:true,
		nav:false,
		pagination:false,  dots: false,
		navText: ["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
	    responsive:{
	        0:{
	            items:1
	        },
	        480:{
	            items:1
	        },
	        700:{
	            items:1
	        },
	        1000:{
	            items:4
	        },
	        1100:{
	            items:4
	        }
	    }
	}); 
    setTimeout(function(){
         var texts=$(".place-name").text();
        texts=texts.replace("Denver","");
        $(".place-name").text(texts);
    }, 4000);
	 
});

$(document).ready(function() {
    var currentUrl = window.location.href;

    // Function to remove the '?' and everything after it
    function removeQueryParameter(url) {
        var index = url.indexOf('?');
        if (index === -1) return url; // No '?' found
        return url.substring(0, index); // Remove everything after '?'
    }

    var cleanUrl = removeQueryParameter(currentUrl);

    // Update the URL in the browser without reloading the page
    window.history.replaceState(null, null, cleanUrl);
});


$(document).on("click",".tab_title a",function(){
  var id_tab=$(this).attr("data-val");
  $(".tab_title a").removeClass("active");
  $(this).addClass("active");
  
  $(".tab_body").removeClass("active");
  $(".tab_body."+id_tab).addClass("active");
});


jQuery(document).ready(function(){
  // Remove 'active' class from all tab buttons and tab bodies initially
  jQuery(".brand-btn").removeClass("active");
  jQuery(".tab_body").removeClass("active");

  // Add 'active' class to the first visible tab button and its corresponding tab body
  jQuery(".brand-btn:visible").first().addClass("active");
  var firstTabDataVal = jQuery(".brand-btn:visible").first().attr("data-val");
  jQuery(".tab_body." + firstTabDataVal).addClass("active");

  // Handle tab button clicks
  jQuery(".brand-btn").click(function(){
    var id_tab = jQuery(this).attr("data-val");

    // Remove 'active' class from all tab buttons and add to the clicked one
    jQuery(".brand-btn").removeClass("active");
    jQuery(this).addClass("active");
    
    // Remove 'active' class from all tab bodies and add to the target one
    jQuery(".tab_body").removeClass("active");
    jQuery(".tab_body." + id_tab).addClass("active");
  });
});





          